import { FunctionComponent } from "react";
import styles from "./SignInLeft.module.css";
import { roles } from "../../../helper";


const SignInLeft: FunctionComponent = () => {
  return (
    <div className={styles.leftPart}>
      <div className={styles.textContainer}>
        <div className={styles.eyebrowText}>
          <div className={styles.divider} />
          <div className={styles.QuickAsystAdminDashboard}>
            QuickAsyst Admin Dashboard 
          </div>
        </div>
        <div className={styles.manageYourTicketing}>
          Manage your ticketing empire from one central hub
        </div>
      </div>
    </div>
  );
};

export default SignInLeft;
